import FilterStore from "../abstract.filter.store";
import {BankModuleServiceInterface, BankModuleStoreInterface,} from "../../types";
import {ActionEnum, ResponseTypeEnum, TranslationDomainEnum} from "../../types/enums";
import {action, makeObservable, observable, runInAction} from "mobx";
import {AppStore} from "../app.store";
import {ApiResponseHandler} from "../../handler/apiResponse.handler";
import {BankListItem} from "../../types/modules/bank/modules";
import {BankAddRequest, BankEditRequest, BankPrepareEditFormRequest, BankViewRequest} from "../../types/modules/bank/request";

export default class BankStore extends FilterStore implements BankModuleStoreInterface {
    public _items: BankListItem[] = [];

    readonly _module: string = 'bank'

    readonly _headers: string[] = [
        'name', 'phone', 'email', 'addressString', 'disabled'
    ]

    public readonly _actions: ActionEnum[] = [
        ActionEnum.VIEW, ActionEnum.EDIT
    ]


    constructor(
        private readonly appStore: AppStore,
        private readonly service: BankModuleServiceInterface
    ) {
        super();

        makeObservable(this, {
            _current: observable,
            _pageSize: observable,
            _orderFieldName: observable,
            _orderDirection: observable,
            _headers: observable,
            _items: observable,
            _loading: observable,
            setTablePaginationData: action,
            setTableFilterData: action,
        });
    }

    setTablePaginationData = ({ current, pageSize, field, order }: any) => {
        this.current = current;
        this.pageSize = pageSize;
        this.orderFieldName = field;
        this.orderDirection = order;
    }

    public list = async () => {
        runInAction(() => {
            this.loading = true;
        });

        return this.service.list({
            ...this.searchFields,
            ...this.paginatorRequestParams,
            checkRoutes: this.accessCheckRequestParams
        })
            .then(({data}) => {
                runInAction(() => {
                    this.items = data.data;
                    this.total = data.totalCount;
                    this.loading = false;
                })
            });
    }

    public edit = async (request: BankEditRequest) => {
        this.appStore.setLoading(true);
        return this.service.edit(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('bank.message.agency_edit_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.COMPANY_ADMINISTRATION)
                return data;
            }).finally(() => {
                this.appStore.setLoading(false);
            });
    }

    public view = async (request: BankViewRequest) => {
        return this.service.view(request)
            .then(({data}) => {
                return data;
            });
    }

    public add = async (request: BankAddRequest) => {
        this.appStore.setLoading(true);
        return this.service.add(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('bank.message.agency_add_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.COMPANY_ADMINISTRATION)
                return data;
            }).finally(() => {
                this.appStore.setLoading(false);
            });
    }

    public prepareEditForm = async (request: BankPrepareEditFormRequest) => {
        return this.service.prepareEditForm(request)
            .then(({data}) => {
                return data;
            });
    }

    public prepareAddForm = async () => {
        return this.service.prepareAddForm()
            .then(({data}) => {
                return data;
            });
    }
}